export default __webpack_public_path__ + "static/media/Bionic-Arm-12.2afd347b.jpg";